import { adapter, PRODUCTS_FEATURE_KEY, ProductsPartialState, ProductsState } from './products.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getProductsState = createFeatureSelector<
  ProductsPartialState,
  ProductsState
>(PRODUCTS_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector(getProductsState, (state: ProductsState) => state.error);

const getAllProducts = createSelector(
  getProductsState,
  selectAll
);

const getAllProductsById = createSelector(
  getProductsState,
  selectEntities
);

const getLastCreatedId = createSelector(getProductsState, (state: ProductsState) => state.lastCreatedId);

const getIsSearching = createSelector(getProductsState, (state: ProductsState) => state.isSearching);

const getSearchResultIds = createSelector(getProductsState, (state: ProductsState) => state.searchResultIds);

const getTextSearchResultIds = createSelector(getProductsState, (state: ProductsState) => state.textSearchResultIds);

const getPagination = createSelector(getProductsState, (state: ProductsState) => state.pagination);

const getFacets = createSelector(getProductsState, (state: ProductsState) => state.facets);

const getSorts = createSelector(getProductsState, (state: ProductsState) => state.sorts);

const getQuery = createSelector(getProductsState, (state: ProductsState) => state.searchQuery);

const getActualSort = createSelector(getProductsState, (state: ProductsState) => state.actualSort);

const getReferenceIds = createSelector(getProductsState, (state: ProductsState) => state.referenceIds);

const getActiveProductId = createSelector(getProductsState, (state: ProductsState) => state.activeId);

const getSearchResults = createSelector(getAllProductsById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
});

const getTextSearchResults = createSelector(getAllProductsById, getTextSearchResultIds, (entities, textSearchResultIds) => {
  return textSearchResultIds.map(id => entities[id]);
});

const getById = createSelector(getAllProductsById, getLastCreatedId, (entities, id) => {
  return entities[id]
});

const getTextSearchTotal = createSelector(getProductsState, (state: ProductsState) => state.textSearchTotal);

const getReferences = createSelector(getAllProductsById, getReferenceIds, (entities, referenceIds) => {
  return referenceIds.map(id => entities[id]);
});

const getSearchTerm = createSelector(getProductsState, (state: ProductsState) => state.searchTerm);

const getNoResult = createSelector(getProductsState, (state: ProductsState) => state.noResult);

export const ProductsQuery = {
  getError,
  getAllProducts,
  getAllProductsById,
  getLastCreatedId,
  getIsSearching,
  getSearchResults,
  getTextSearchResults,
  getPagination,
  getFacets,
  getSorts,
  getQuery,
  getActualSort,
  getReferences,
  getActiveProductId,
  getById,
  getSearchTerm,
  getNoResult,
  getTextSearchTotal
};
